module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form', {
    ref: "form",
    staticClass: "displayForm",
    attrs: {
      "model": _vm.entity,
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "工号",
      "prop": "employeeNo"
    }
  }, [_vm._v("\r\n         " + _vm._s(_vm.entity.employeeNo) + "\r\n        ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "姓名"
    }
  }, [_vm._v("\r\n           " + _vm._s(_vm.entity.realName) + "\r\n        ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "所属部门",
      "prop": "orgId"
    }
  }, [_vm._v("\r\n            " + _vm._s((_vm.entity.sysOrgDTO || {}).orgName) + "\r\n        ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "联系电话",
      "prop": "sysAccount.telNo"
    }
  }, [_vm._v("\r\n           " + _vm._s(_vm.entity.telNo) + "\r\n        ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "邮箱",
      "prop": "email"
    }
  }, [_vm._v("\r\n          " + _vm._s(_vm.entity.email) + "\r\n        ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "备注",
      "prop": "remark"
    }
  }, [_vm._v("\r\n          " + _vm._s(_vm.entity.remark) + "\r\n        ")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-72ad3484","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/layout/PersonalInfo.vue
// module id = 346
// module chunks = 0